export interface MediaAlt {
  locale: string
  text: string
}

const mediaAltLocaleMap: Partial<Record<string, string>> = {
  en: 'en',
  'zh-CN': 'zh-Hans',
  'zh-HK': 'zh-Hant',
  jp: 'ja',
  kr: 'ko',
  de: 'de',
  es: 'es',
  it: 'it',
  fr: 'fr',
}

/**
 * 仅解析已与后台确认的语言，避免用前端语言码猜测后台 locale。
 * 未支持的语言返回 undefined，方便调用方保持原有行为。
 */
export function resolveMediaAlt(alts: MediaAlt[] | null | undefined, locale?: string): string | undefined {
  if (!locale) return undefined

  const mediaAltLocale = mediaAltLocaleMap[locale]
  if (!mediaAltLocale) return undefined

  return alts?.find((item) => item.locale === mediaAltLocale)?.text ?? ''
}
